export default __webpack_public_path__ + "static/media/Savings1.900d7bbb.png";